'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxPagan = require('redux-pagan');
var _reduxForm = require('redux-form');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _lodash = require('lodash');
var _reactScroll = require('react-scroll');

var _MyStaffUserCard = require('../../components/MyStaffUserCard/MyStaffUserCard');var _MyStaffUserCard2 = _interopRequireDefault(_MyStaffUserCard);
var _MyStaffEmployeesCard = require('../../components/MyStaffEmployeesCard/MyStaffEmployeesCard');var _MyStaffEmployeesCard2 = _interopRequireDefault(_MyStaffEmployeesCard);

var _myStaff = require('../../redux/modules/myStaff');








var _myStaffEmployees = require('../../redux/modules/myStaffEmployees');








var _manageProperties = require('../../redux/modules/manageProperties');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _components = require('./components');







var _components2 = require('../../components');
var _RealtorLandingPublishFormModal = require('../RealtorLandingPublishForm/RealtorLandingPublishFormModal');var _RealtorLandingPublishFormModal2 = _interopRequireDefault(_RealtorLandingPublishFormModal);
var _PaginationStaff = require('./components/Pagination/PaginationStaff');var _PaginationStaff2 = _interopRequireDefault(_PaginationStaff);
var _AddNewStaffEmployeesForm = require('./components/AddNewStaffEmployeesForm/AddNewStaffEmployeesForm');var _AddNewStaffEmployeesForm2 = _interopRequireDefault(_AddNewStaffEmployeesForm);

var _assetsToDelete = require('../../redux/modules/assetsToDelete');


var _messageModal = require('../../redux/modules/messageModal');




var _constants = require('../../constants');
var _Constants = require('./Constants');





var _MyStaffContainer = require('./MyStaffContainer.scss');var styles = _interopRequireWildcard(_MyStaffContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Helpers
// Constants
// Styles
var MyStaffContainer = function (_Component) {_inherits(MyStaffContainer, _Component);function MyStaffContainer(props) {_classCallCheck(this, MyStaffContainer);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



























































    getPagination = function (name) {var _this$props =
      _this.props,userToken = _this$props.userToken,myStaff = _this$props.myStaff;
      var filters = Object.assign({},
      myStaff.filter.search_field && { search_field: myStaff.filter.search_field },
      myStaff.filter.search_value && { search_value: myStaff.filter.search_value });

      if (typeof localStorage !== 'undefined') {
        try {
          var selectedPages = JSON.parse(localStorage.getItem(name));
          if (selectedPages) {
            _this.setState({ rowsOnPage: selectedPages }, function () {var
              rowsOnPage = _this.state.rowsOnPage;
              _this.props.getMyStaff({
                token: userToken,
                params: Object.assign({ $limit: rowsOnPage.value }, filters) });

            });
          }
        } catch (e) {
          console.error('Failed to read ' + name + ' from localStorage');
        }
      }
      _this.props.getMyStaff({ token: userToken, params: Object.assign({ $limit: 10 }, filters) });
    };_this.

    getEmployeesPagination = function (name) {var _this$props2 =
      _this.props,userToken = _this$props2.userToken,myStaffEmployees = _this$props2.myStaffEmployees;
      var filters = Object.assign({},
      myStaffEmployees.filter.search_field && { search_field: myStaffEmployees.filter.search_field },
      myStaffEmployees.filter.search_value && { search_value: myStaffEmployees.filter.search_value });

      if (typeof localStorage !== 'undefined') {
        try {
          var selectedPages = JSON.parse(localStorage.getItem(name));
          if (selectedPages) {
            _this.setState({ rowsEmployeesOnPage: selectedPages }, function () {var
              rowsEmployeesOnPage = _this.state.rowsEmployeesOnPage;
              _this.props.getMyStaffEmployees({
                token: userToken,
                params: Object.assign({ $limit: rowsEmployeesOnPage.value }, filters) });

            });
          }
        } catch (e) {
          console.error('Failed to read ' + name + ' from localStorage');
        }
      }
      _this.props.getMyStaffEmployees({ token: userToken, params: Object.assign({ $limit: 10 }, filters) });
    };_this.

    addAssetToDelete = function (_ref) {var publicId = _ref.publicId,contentType = _ref.contentType;
      _this.props.addAssetToDelete({ id: publicId, type: contentType });
    };_this.

    handleGetMyStaff = function () {var _this$props3 =
      _this.props,userToken = _this$props3.userToken,currentPaginationStep = _this$props3.currentPaginationStep,myStaff = _this$props3.myStaff;var
      value = _this.state.rowsOnPage.value;
      var filters = Object.assign({},
      myStaff.filter.search_field && { search_field: myStaff.filter.search_field },
      myStaff.filter.search_value && { search_value: myStaff.filter.search_value });


      _this.props.getMyStaff({
        token: userToken,
        params: Object.assign({
          $limit: value,
          $skip: currentPaginationStep - 1 },
        filters) });


    };_this.

    handleGetMyStaffEmployees = function () {var _this$props4 =
      _this.props,userToken = _this$props4.userToken,currentPaginationStepEmployees = _this$props4.currentPaginationStepEmployees,myStaffEmployees = _this$props4.myStaffEmployees;var
      value = _this.state.rowsEmployeesOnPage.value;
      var filters = Object.assign({},
      myStaffEmployees.filter.search_field && { search_field: myStaffEmployees.filter.search_field },
      myStaffEmployees.filter.search_value && { search_value: myStaffEmployees.filter.search_value });


      _this.props.getMyStaffEmployees({
        token: userToken,
        params: Object.assign({
          $limit: value,
          $skip: currentPaginationStepEmployees - 1 },
        filters) });


    };_this.

    scrollToTop = function () {
      if (_this.props.isMobile) {
        setTimeout(function () {return _this.scrollTo();}, 501);
      } else {
        _this.scrollTo();
      }
    };_this.

    scrollTo = function () {var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anchor-top';var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true,
        offset: -55 },
      options));

    };_this.

    closeFormModal = function () {return _this.setState({ isContactModalOpen: false });};_this.
    openFormModal = function () {return _this.setState({ isContactModalOpen: true });};_this.

    closeAddUserFailModal = function () {return _this.setState({ isAddUserFailModal: false });};_this.
    openAddUserFailModal = function () {return _this.setState({ isAddUserFailModal: true });};_this.

    closeAddEmployeeFailModal = function () {return _this.setState({ isAddEmployeeFailModal: false });};_this.

    openAddEmployeeFailModal = function () {return _this.setState({ isAddEmployeeFailModal: true });};_this.

    changePagination = function (value) {
      _this.setState({ rowsOnPage: value });
      var serializedVal = JSON.stringify(value);
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('rows-on-my-staff-page', serializedVal);
      }var _this$props5 =
      _this.props,userToken = _this$props5.userToken,currentPaginationStep = _this$props5.currentPaginationStep,myStaff = _this$props5.myStaff;
      var filters = Object.assign({},
      myStaff.filter.search_field && { search_field: myStaff.filter.search_field },
      myStaff.filter.search_value && { search_value: myStaff.filter.search_value });


      _this.props.getMyStaff({
        token: userToken,
        params: Object.assign({
          $limit: value.value,
          $skip: currentPaginationStep - 1 },
        filters) });


    };_this.

    handleForward = function () {
      var step = _this.props.currentPaginationStep + _this.state.rowsOnPage.value;
      if (step <= _this.props.myStaff.totalUsersCount) {
        _this.props.setCurrentPaginationStep(step);

        if (document) {
          _this.scrollToTop();
        }
      }
    };_this.

    handleBack = function () {
      var step = _this.props.currentPaginationStep - _this.state.rowsOnPage.value;
      _this.props.setCurrentPaginationStep(step > 1 ? step : 1);
      if (document && step >= 1) {
        _this.scrollToTop();
      }
    };_this.

    handleGoTo = function (val) {
      if (!Number.isNaN(val) && val >= 0) {
        _this.props.setCurrentPaginationStep(val);
        _this.setState({ selected: val });
      }
    };_this.

    changeEmployeesPagination = function (value) {
      _this.setState({ rowsEmployeesOnPage: value });
      localStorage.setItem('rows-on-my-listed-only-staff-page', JSON.stringify(value));var _this$props6 =
      _this.props,userToken = _this$props6.userToken,currentPaginationStepEmployees = _this$props6.currentPaginationStepEmployees,myStaffEmployees = _this$props6.myStaffEmployees;
      var filters = Object.assign({},
      myStaffEmployees.filter.search_field && { search_field: myStaffEmployees.filter.search_field },
      myStaffEmployees.filter.search_value && { search_value: myStaffEmployees.filter.search_value });


      _this.props.getMyStaffEmployees({
        token: userToken,
        params: Object.assign({
          $limit: value.value,
          $skip: currentPaginationStepEmployees - 1 },
        filters) });


    };_this.

    handleForwardEmployees = function () {
      var step = _this.props.currentPaginationStepEmployees + _this.state.rowsEmployeesOnPage.value;
      if (step <= _this.props.myStaffEmployees.totalEmployees) {
        _this.props.setCurrentPaginationStepEmployees(step);
        _this.scrollToTop();
      }
    };_this.

    handleBackEmployees = function () {
      var step = _this.props.currentPaginationStepEmployees - _this.state.rowsEmployeesOnPage.value;
      _this.props.setCurrentPaginationStepEmployees(step > 1 ? step : 1);
      _this.scrollToTop();
    };_this.

    handleGoToEmployees = function (val) {
      if (!Number.isNaN(val) && val >= 0) {
        _this.props.setCurrentPaginationStepEmployees(val);
        _this.setState({ selected: val });
      }
    };_this.

    changeImages = function (data, formName) {
      var publicId = null;
      var image = data.length ? data[0] : {};

      if (data.length) {
        publicId = image.public_id ? image.public_id : image.full && image.full.split('/').pop();
      }

      var employeeImage = {
        link: publicId,
        angle: image.angle || 0 };


      _this.setState({ isChangeImg: true });
      _this.props.changeValue(formName, 'image', employeeImage);
    };_this.

    changeImagesAdd = function (data) {
      _this.changeImages(data, 'add-my-staff-employee');
    };_this.

    makeChangeImagesUpdate = function (id) {return function (data) {
        _this.changeImages(data, 'my-staff-employee-update-' + id);
      };};_this.

    renderStaffCard = function () {var _this$props7 =
      _this.props,myStaff = _this$props7.myStaff,translate = _this$props7.translate,isMobile = _this$props7.isMobile;

      return myStaff.data.map(function (item) {return (
          _react2.default.createElement(_MyStaffUserCard2.default, _extends({
            key: item.id },
          item, {
            metaStaff: myStaff.meta,
            isDraft: !item.assigned_to_agency_id,
            myStaff: myStaff,
            isMobile: isMobile,
            translate: translate,
            editUser: _this.props.editUser,
            deleteUser: _this.props.deleteUser,
            userToken: _this.props.userToken })));});


    };_this.

    renderEmployeesCard = function () {var _this$props8 =
      _this.props,myStaffEmployees = _this$props8.myStaffEmployees,translate = _this$props8.translate,isMobile = _this$props8.isMobile;
      return myStaffEmployees.data.map(function (item) {return (
          _react2.default.createElement(_MyStaffEmployeesCard2.default, _extends({
            key: item.id },
          item, {
            metaEmployees: myStaffEmployees.meta,
            myStaffEmployees: myStaffEmployees,
            isMobile: isMobile,
            translate: translate,
            editEmployee: _this.props.editEmployee,
            deleteEmployee: _this.props.deleteEmployee,
            userToken: _this.props.userToken,
            changeValue: _this.props.changeValue,
            openMessageModal: _this.props.openMessageModal,
            addAssetToDelete: _this.addAssetToDelete,
            changeImages: _this.makeChangeImagesUpdate(item.id) })));});


    };_this.

    renderContactFormModal = function () {return (
        _react2.default.createElement(_components2.Modal, {
            className: 'publishFormContactUsModal',
            isOpen: _this.state.isContactModalOpen,
            onRequestClose: _this.closeFormModal,
            isRtl: _this.props.isRtl,
            withoutTitle: true },

          _react2.default.createElement(_RealtorLandingPublishFormModal2.default, {
            inModal: true,
            formModalIsOpen: _this.state.isContactModalOpen,
            handleRequest: _this.closeFormModal })));};_this.




    renderPrimaryTab = function (_ref2) {var
      myStaff = _ref2.myStaff,
      isMobile = _ref2.isMobile,
      translate = _ref2.translate,
      userProperties = _ref2.userProperties,
      isRtl = _ref2.isRtl,
      userToken = _ref2.userToken,
      addNewStaffFormOpen = _ref2.addNewStaffFormOpen;return (

        _react2.default.createElement(_components2.OMTab, { id: _constants.myStaffViews.PRIMARY, title: '' + _this.props.translate('editProfile', 'primaryStaff') },
          _react2.default.createElement('div', { className: styles.contentWrapper },
            _react2.default.createElement('div', { className: styles.cardWrapper },
              myStaff.loaded && !myStaff.meta.totalUsersCount && _react2.default.createElement('p', { className: styles.subtitle }, translate('myStaff', 'noLengthStaff')),
              _this.renderStaffCard(),

              _this.props.myStaff.totalUsersCount > 10 &&
              !!myStaff.data.length &&
              _react2.default.createElement(_PaginationStaff2.default, {
                selected: _this.state.selected,
                current: _this.props.currentPaginationStep,
                total: myStaff.totalUsersCount,
                rowsPerPage: _this.state.rowsOnPage,
                onForward: _this.handleForward,
                onBack: _this.handleBack,
                onGoTo: _this.handleGoTo,
                onRowsChange: _this.changePagination,
                isMobile: isMobile,
                translate: translate })),



            _react2.default.createElement('div', { className: styles.controlUnitWrapper },
              _react2.default.createElement(_components.SearchEmployees, {
                title: _this.props.translate('myStaff', 'searchStaff'),
                description: _this.props.translate('myStaff', 'searchStaffDescription'),
                translate: translate,
                userToken: userToken,
                onHandleSearch: _this.props.getMyStaff,
                searchOptions: _Constants.SEARCH_OPTIONS }),

              !isMobile &&
              _react2.default.createElement(_components.QuickTeamAdd, {
                title: _this.props.translate('myStaff', 'quickTeamAdd'),
                handleClick: _this.props.openAddNewStaffForm,
                translate: translate,
                btnText: _this.props.translate('myStaff', 'addNewStaffButton'),
                description: _this.props.translate('myStaff', 'quickTeamAddStaffDescription') }),


              !isMobile &&
              _react2.default.createElement(_components.MyPropertiesBlock, {
                isRtl: isRtl,
                userProperties: userProperties,
                openFormModal: _this.openFormModal,
                translate: translate,
                metaStaff: myStaff.meta })),



            isMobile &&
            _react2.default.createElement(_components.FooterMyStaff, {
              btnText: _this.props.translate('myStaff', 'addNewStaffButton'),
              openAddNewStaffForm: _this.props.openAddNewStaffForm,
              translate: translate,
              openFormModal: _this.openFormModal,
              userProperties: userProperties,
              metaStaff: myStaff.meta,
              isRtl: isRtl })),



          _react2.default.createElement(_components2.Modal, {
              isOpen: addNewStaffFormOpen,
              className: styles.modal,
              onRequestClose: _this.props.closeAddNewStaffForm },

            _react2.default.createElement(_components.AddNewStaffForm, {
              isRtl: isRtl,
              userToken: userToken,
              addUser: _this.props.addUser,
              translate: translate,
              addUserLoading: _this.props.myStaff.addUserLoading,
              metaStaff: myStaff.meta })),


          _react2.default.createElement(_components.ModalError, {
            isOpen: _this.state.isAddUserFailModal,
            translate: translate,
            error: _this.props.myStaff.error,
            onRequestClose: _this.closeAddUserFailModal })));};_this.




    renderEmployeesTab = function (_ref3) {var
      myStaffEmployees = _ref3.myStaffEmployees,
      addNewStaffEmployeesFormOpen = _ref3.addNewStaffEmployeesFormOpen,
      isMobile = _ref3.isMobile,
      translate = _ref3.translate,
      userToken = _ref3.userToken,
      isRtl = _ref3.isRtl;return (

        _react2.default.createElement(_components2.OMTab, { id: _constants.myStaffViews.LISTED, title: '' + _this.props.translate('editProfile', 'listedOnly') },
          _react2.default.createElement('div', { className: styles.contentWrapper },
            _react2.default.createElement('div', { className: styles.cardWrapper },
              myStaffEmployees.loaded && !myStaffEmployees.meta.total && _react2.default.createElement('p', { className: styles.subtitle }, translate('myStaff', 'noLengthEmployee')),
              _this.renderEmployeesCard(),

              myStaffEmployees.totalEmployees > 10 &&
              !!myStaffEmployees.data.length &&
              _react2.default.createElement(_PaginationStaff2.default, {
                selected: _this.state.selectedEmployees,
                current: _this.props.currentPaginationStepEmployees,
                total: myStaffEmployees.totalEmployees,
                rowsPerPage: _this.state.rowsEmployeesOnPage,
                onForward: _this.handleForwardEmployees,
                onBack: _this.handleBackEmployees,
                onGoTo: _this.handleGoToEmployees,
                onRowsChange: _this.changeEmployeesPagination,
                isMobile: isMobile,
                translate: translate })),



            _react2.default.createElement('div', { className: styles.controlUnitWrapper },
              _react2.default.createElement(_components.SearchEmployees, {
                title: _this.props.translate('myStaff', 'searchEmployees'),
                description: _this.props.translate('myStaff', 'searchDescription'),
                translate: translate,
                userToken: userToken,
                onHandleSearch: _this.props.getMyStaffEmployees,
                searchOptions: _Constants.BASE_SEARCH_OPTIONS }),

              !isMobile &&
              _react2.default.createElement(_components.QuickTeamAdd, {
                title: _this.props.translate('myStaff', 'quickTeamAddListedMember'),
                handleClick: _this.props.openAddNewStaffEmployeesForm,
                translate: translate,
                btnText: _this.props.translate('myStaff', 'addNewEmployeeButton') })),



            isMobile &&
            _react2.default.createElement(_components.FooterMyStaff, {
              btnText: _this.props.translate('myStaff', 'addNewEmployeeButton'),
              openAddNewStaffForm: _this.props.openAddNewStaffEmployeesForm,
              translate: translate,
              openFormModal: _this.openFormModal,
              metaStaff: myStaffEmployees.meta,
              isRtl: isRtl })),



          _react2.default.createElement(_components2.Modal, {
              isOpen: addNewStaffEmployeesFormOpen,
              className: styles.modal,
              onRequestClose: _this.props.closeAddNewStaffEmployeesForm },

            _react2.default.createElement(_AddNewStaffEmployeesForm2.default, {
              isRtl: isRtl,
              userToken: userToken,
              addEmployee: _this.props.addEmployee,
              translate: translate,
              addEmployeeLoading: _this.props.myStaffEmployees.addEmployeeLoading,
              metaEmployees: myStaffEmployees.meta,
              isMobile: isMobile,
              changeValue: _this.props.changeValue,
              openMessageModal: _this.props.openMessageModal,
              changeImages: _this.changeImagesAdd })),


          _react2.default.createElement(_components.ModalError, {
            isOpen: _this.state.isAddEmployeeFailModal,
            translate: translate,
            error: _this.props.myStaffEmployees.error,
            onRequestClose: _this.closeAddEmployeeFailModal })));};_this.state = { isContactModalOpen: false, isAddUserFailModal: false, isAddEmployeeFailModal: false, rowsOnPage: { value: 10, label: 10 }, rowsEmployeesOnPage: { value: 10, label: 10 }, selected: 1, selectedEmployees: 1, isChangeImg: false };_this.debouncedGetMyStaff = (0, _lodash.debounce)(_this.handleGetMyStaff, 1000);_this.debouncedGetMyStaffEmployees = (0, _lodash.debounce)(_this.handleGetMyStaffEmployees, 1000);return _this;}MyStaffContainer.prototype.componentDidMount = function componentDidMount() {this.getPagination('rows-on-my-staff-page');this.getEmployeesPagination('rows-on-my-listed-only-staff-page');};MyStaffContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (newProps.currentPaginationStep !== this.props.currentPaginationStep) {this.debouncedGetMyStaff();}if (newProps.currentPaginationStepEmployees !== this.props.currentPaginationStepEmployees) {this.debouncedGetMyStaffEmployees();}if (newProps.myStaff.addUserLoaded && newProps.myStaff.addUserLoaded !== this.props.myStaff.addUserLoaded) {newProps.closeAddNewStaffForm();}if (newProps.myStaffEmployees.addEmployeeLoaded && newProps.myStaffEmployees.addEmployeeLoaded !== this.props.myStaffEmployees.addEmployeeLoaded) {newProps.closeAddNewStaffEmployeesForm();}if (newProps.myStaff.error && newProps.myStaff.error !== this.props.myStaff.error) {this.openAddUserFailModal();newProps.closeAddNewStaffForm();}if (newProps.myStaffEmployees.error && newProps.myStaffEmployees.error !== this.props.myStaffEmployees.error) {this.openAddEmployeeFailModal();newProps.closeAddNewStaffEmployeesForm();}if ((0, _lodash.get)(newProps.myStaff, 'meta.totalUsersCount', 0) !== (0, _lodash.get)(this.props.myStaff, 'meta.totalUsersCount', 0) || (0, _lodash.get)(newProps.myStaff, 'meta.canAddProperties', 0) !== (0, _lodash.get)(this.props.myStaff, 'meta.canAddProperties', 0) || (0, _lodash.get)(newProps.myStaff, 'meta.canAddColorPromotions', 0) !== (0, _lodash.get)(this.props.myStaff, 'meta.canAddColorPromotions', 0) || (0, _lodash.get)(newProps.myStaff, 'meta.canAddTopPromotions', 0) !== (0, _lodash.get)(this.props.myStaff, 'meta.canAddTopPromotions', 0) || (0, _lodash.get)(newProps.myStaffEmployees, 'meta.total', 0) !== (0, _lodash.get)(this.props.myStaffEmployees, 'meta.total', 0)) {console.log('LOADING PROPERTIES', newProps.myStaff.meta);this.props.loadUserProperties({ token: newProps.userToken });}};MyStaffContainer.prototype.




  render = function render() {var _props =











    this.props,myStaff = _props.myStaff,isMobile = _props.isMobile,translate = _props.translate,addNewStaffFormOpen = _props.addNewStaffFormOpen,userProperties = _props.userProperties,isRtl = _props.isRtl,userToken = _props.userToken,myStaffEmployees = _props.myStaffEmployees,addNewStaffEmployeesFormOpen = _props.addNewStaffEmployeesFormOpen,changeValue = _props.changeValue;

    var primaryTabProps = {
      myStaff: myStaff,
      isMobile: isMobile,
      translate: translate,
      addNewStaffFormOpen: addNewStaffFormOpen,
      userProperties: userProperties,
      isRtl: isRtl,
      userToken: userToken };


    var employeesTabProps = {
      isMobile: isMobile,
      translate: translate,
      userToken: userToken,
      myStaffEmployees: myStaffEmployees,
      isRtl: isRtl,
      addNewStaffEmployeesFormOpen: addNewStaffEmployeesFormOpen,
      changeValue: changeValue };


    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement(_reactScroll.Element, { name: 'anchor-top' }),
        _react2.default.createElement('p', { className: styles.title }, translate('myStaff', 'title')),
        _react2.default.createElement(_components2.OMTabs, {
            defaultActiveTabKey: _constants.myStaffViews.PRIMARY,
            className: styles.staffTabs,
            locale: this.props.locale,
            withLink: true },

          this.renderPrimaryTab(primaryTabProps),
          this.renderEmployeesTab(employeesTabProps)),

        this.renderContactFormModal()));


  };return MyStaffContainer;}(_react.Component);


MyStaffContainer.propTypes = {
  translate: _propTypes2.default.func,
  openAddNewStaffForm: _propTypes2.default.func,
  myStaff: _propTypes2.default.object,
  getMyStaff: _propTypes2.default.func,
  addUser: _propTypes2.default.func,
  closeAddNewStaffForm: _propTypes2.default.func,
  deleteUser: _propTypes2.default.func,
  editUser: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  loadUserProperties: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  userProperties: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  addNewStaffFormOpen: _propTypes2.default.bool,
  currentPaginationStep: _propTypes2.default.number,
  myStaffEmployees: _propTypes2.default.object,
  getMyStaffEmployees: _propTypes2.default.func,
  addEmployee: _propTypes2.default.func,
  deleteEmployee: _propTypes2.default.func,
  editEmployee: _propTypes2.default.func,
  setCurrentPaginationStepEmployees: _propTypes2.default.func,
  currentPaginationStepEmployees: _propTypes2.default.number,
  addNewStaffEmployeesFormOpen: _propTypes2.default.bool,
  openAddNewStaffEmployeesForm: _propTypes2.default.func,
  closeAddNewStaffEmployeesForm: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  changeValue: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  currentView: _propTypes2.default.string };


var changeValue = function changeValue(formName, name, value) {return (0, _reduxForm.change)(formName, name, value);};

var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    userToken: (0, _lodash.get)(state, 'userAuthentication.data.access_token'),
    isMobile: state.windowDimentions.isMobile,
    userProperties: state.manageProperties,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    addNewStaffFormOpen: state.myStaff.addNewStaffFormOpen,
    myStaff: state.myStaff,
    currentPaginationStep: state.myStaff.currentPaginationStep,
    myStaffEmployees: state.myStaffEmployees,
    currentPaginationStepEmployees: state.myStaffEmployees.currentPaginationStepEmployees,
    addNewStaffEmployeesFormOpen: state.myStaffEmployees.addNewStaffEmployeesFormOpen,
    changeValue: _propTypes2.default.func };};


var mapDispatchToProps = {
  addUser: _myStaff.addUser,
  editUser: _myStaff.editUser,
  getMyStaff: _myStaff.getMyStaff,
  deleteUser: _myStaff.deleteUser,
  openAddNewStaffForm: _myStaff.openAddNewStaffForm,
  closeAddNewStaffForm: _myStaff.closeAddNewStaffForm,
  setCurrentPaginationStep: _myStaff.setCurrentPaginationStep,
  getMyStaffEmployees: _myStaffEmployees.getMyStaffEmployees,
  addEmployee: _myStaffEmployees.addEmployee,
  deleteEmployee: _myStaffEmployees.deleteEmployee,
  editEmployee: _myStaffEmployees.editEmployee,
  openAddNewStaffEmployeesForm: _myStaffEmployees.openAddNewStaffEmployeesForm,
  closeAddNewStaffEmployeesForm: _myStaffEmployees.closeAddNewStaffEmployeesForm,
  setCurrentPaginationStepEmployees: _myStaffEmployees.setCurrentPaginationStepEmployees,
  loadUserProperties: _manageProperties.loadUserProperties,
  changeValue: changeValue,
  openMessageModal: _messageModal.openMessageModal,
  addAssetToDelete: _assetsToDelete.addAssetToDelete };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
MyStaffContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/MyStaffContainer.js
// module id = 2968
// module chunks = 0